
<template>
  <div class="kay-data-table">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-12">
              <div class="card-header">
                <h4 class="card-title">入口管理 - 入口列表</h4>
              </div>
              <div class="card-body">
                <!-- <router-link to="./gaa-users/new" type="success">
                  <n-button type="success">建立 GAA 管理員</n-button>
                </router-link>-->
                <p>可於此頁面新增入口參數、新增刪除商店</p>
                <div class="my-3"><b style="color:#BA0000;">注意！訂單入口、點餐入口都是根據此設定，因此既有設定請不要隨意更動</b></div>
                <el-row :gutter="20">
                  <el-col :xs="24" :md="6">
                    <el-input
                      v-model="filters[0].value"
                      placeholder="搜尋入口"
                      size="small"
                      prefix-icon="el-icon-search"
                    ></el-input>
                  </el-col>
                  <el-col :xs="48" :md="12">
                    <router-link to="./portals/new" type="success">
                      <el-button type="primary" size="small"><i class="el-icon-circle-plus">新增入口</i></el-button>
                    </router-link>

                    <router-link to="./portals/shops" type="success">
                      <el-button type="success" style="background-color: #9050cc;border-color: #9050cc;" size="small">查看店家目前上架到哪些Portal</el-button>
                    </router-link>
                  </el-col>
                </el-row>

                <data-tables :data="data" :filters="filters" :action-col="actionCol">
                  <el-table-column
                    v-for="title in titles"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.prop"
                    sortable="custom"
                  ></el-table-column>
                  <el-table-column label="LOGO" prop="logo" sortable="custom" min-width="50px">
                    <template slot-scope="scope"><img :src="scope.row.logo"></template>
                  </el-table-column>
                  <el-table-column label="FAVICON" prop="favicon" sortable="custom" min-width="50px">
                    <template slot-scope="scope"><img :src="scope.row.favicon"></template>
                  </el-table-column>
                  <el-table-column label="預設商店圖" prop="defaultShops" sortable="custom" min-width="50px">
                    <template slot-scope="scope"><img :src="scope.row.defaultShops"></template>
                  </el-table-column>
                </data-tables>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      data: [],
      titles: [
        // {
        //   prop: "id",
        //   label: "NO."
        // },
        {
          prop: "portalKey",
          label: "入口KEY"
        },
        {
          prop: "title",
          label: "頁面標題"
        },
        {
          prop: "tabSetting",
          label: "頁面配置"
        },
         {
          prop: "orderCount",
          label: "累計訂單數"
        }
      ],
      actionCol: {
        label: "操作",
        props: {
          align: "center",
          width: "300"
        },
        buttons: [
          {
            props: {
              type: "success",
              size: "small",
              icon: "el-icon-s-marketing"
            },
            label: "商店",
            handler: row => {
              this.$router.push(`/portals/${row.portalKey}/shops`);
            }
          },
          {
            props: {
              type: "warning",
              size: "small",
              icon: "el-icon-setting"
            },
            label: "設定",
            handler: row => {
              this.$router.push(`/portals/${row.portalKey}/edit`);
            }
          }
        ]
      },
      filters: [
        {
          value: "",
          prop: ["title", "portalKey"]
        },
        {
          value: []
        }
      ]
    };
  },
  methods: {
    handleClick(command) {
      this.$message(`click dropdown button ${command}`);
    },
    getCampaignGroups() {
      return axios
        .get(`${process.env.VUE_APP_APIHOST}/gaa/portals`)
        .then(response => {
          this.data = response.data;
         
          return response.data;
        });
    }
  },
  mounted() {
    this.getCampaignGroups();
  }
};
</script>
<style scoped>
.kay-data-table .btn-base,
.el-select .el-input .el-input__inner,
.btn,
.navbar .navbar-nav > a.btn {
  margin: 0px !important;
}
</style>